export const BootNotification = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginRight: "12px" }}
    >
      <g clipPath="url(#clip0_3487_14283)">
        <path
          d="M7.32239 16.5C8.52979 16.5 9.53979 15.6393 9.77173 14.5H4.87305C5.1051 15.6393 6.11511 16.5 7.32239 16.5Z"
          fill="#2469F3"
        />
        <path
          d="M11.998 8.49951C11.9953 8.49951 11.9926 8.50012 11.9899 8.50012C9.41728 8.50012 7.32329 6.40674 7.32329 3.8335C7.32329 3.1261 7.48601 2.4574 7.76934 1.85608C7.62261 1.84216 7.47393 1.8335 7.32329 1.8335C4.74602 1.8335 2.65667 3.92273 2.65667 6.50012V8.35876C2.65667 9.6781 2.07866 10.9235 1.06462 11.7808C0.726611 12.0695 0.576587 12.5294 0.697925 12.9781C0.839282 13.5001 1.35527 13.8335 1.89666 13.8335H12.7466C13.3146 13.8335 13.85 13.4655 13.9653 12.9088C14.0546 12.4781 13.9013 12.0481 13.5673 11.7675C12.5979 10.9548 12.0373 9.76074 11.998 8.49951Z"
          fill="#2469F3"
        />
        <path
          d="M15.3229 3.83337C15.3229 5.67432 13.8306 7.16663 11.9895 7.16663C10.1486 7.16663 8.65625 5.67432 8.65625 3.83337C8.65625 1.99243 10.1486 0.5 11.9895 0.5C13.8306 0.5 15.3229 1.99243 15.3229 3.83337Z"
          fill="#2469F3"
        />
      </g>
      <defs>
        <clipPath id="clip0_3487_14283">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}